import React from "react";

function Section_9() {
  return (
    <section className="csrd-landing-page-section-9-container">
      <div className="section-9-banner">
        <div className="section-9-left-content-container"></div>
        <div className="section-9-right-content-container">
          <div
            className="section-9-header"
            data-aos="fade-in"
            data-aos-delay="100"
            data-aos-duration="1500"
            data-aos-once="true">
            With end-to-end automation, AI-driven materiality assessments, and seamless XBRL
            reporting{" "}
          </div>
          <div
            className="section-9-description"
            data-aos="fade-in"
            data-aos-delay="100"
            data-aos-duration="1500"
            data-aos-once="true">
            Updapt simplifies CSRD compliance, allowing businesses to focus on driving sustainable
            impact while meeting regulatory requirements.
          </div>
        </div>
      </div>
      <div className="section-9-bottom-content-container">
        <div className="section-9-header">
          With end-to-end automation, AI-driven materiality assessments, and seamless XBRL reporting{" "}
        </div>
        <div className="section-9-description">
          Updapt simplifies CSRD compliance, allowing businesses to focus on driving sustainable
          impact while meeting regulatory requirements.
        </div>
      </div>
    </section>
  );
}

export default Section_9;
